import classes from "../Table/Table.module.css";
import { Fragment, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ActiveCurrenciesContext from "../../providers/CurrencyProvider";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import GlobalProvider from "../../providers/GlobalProvider";

export default function TableComponent({
  columnTitle,
  opsArray,
  opsIdProperty,
  opsDisplayProperty,

  branchArray,
  branchIdProperty,
  branchDisplayProperty,

  salesmanArray,
  salesmanIdProperty,
  salesmanDisplayProperty,

  /** list of currencies from Libra */
  accCurrArray,
  accCurrIdProperty,
  accCurrDisplayProperty,

  accountingArray,
  accountingIdProperty,
  accountingDisplayProperty,

  /** existing vendor or client matches */
  existingMatches,

  /** properties of VendorClientMatchingDto */
  matchingOpsIdProperty,
  matchingLibraIdProperty,
  matchingBranchIdProperty,
  matchingSalesmanIdProperty,
  matchingAccCurrCode,

  handleSave,
  handleUpdate,
  handleDelete,
}) {
  let f1, f2, f3, f4, accCurrencies;
  const { activeCurrencies } = useContext(ActiveCurrenciesContext);
  const [newEntry, setNewEntry] = useState({
    selectedOps: "",
    selectedAccounting: "",
    selectedBranch: "",
    selectedSalesman: "",
    selectedAccCurr: [],
  });

  const [matches, setMatches] = useState([]);
  const [oldBranchId, setOldBranchId] = useState();
  const [filteredArrays, setFilteredArrays] = useState({
    ops: opsArray,
    accounting: accountingArray,
    branch: branchArray,
    salesman: salesmanArray,
    accountCurrencies: accCurrArray,
  });
  // combine in one state
  const [disabled, setDisabled] = useState(false);
  const [disabledMain, setDisabledMain] = useState(true);
  const [disableSave, setDisableSave] = useState(true);
  const [editRowId, setEditRowId] = useState(null);
  const opsOptions = filteredArrays.ops.map((item) => ({
    value: item[opsIdProperty],
    label: item[opsDisplayProperty],
  }));
  const { defaultMapper } = useContext(GlobalProvider);
  const IASLiveMapper = "IAS Libra Live";

  const getDisplay = (matching) => {
    let foundOps, foundAccounting, foundBranch, foundSalesman;

    foundOps = opsArray.find(
      (obj) =>
        obj[opsIdProperty].toUpperCase() ===
        matching[matchingOpsIdProperty].toUpperCase()
    );

    foundAccounting = accountingArray.find(
      (obj) =>
        obj[accountingIdProperty] ===
        matching[matchingLibraIdProperty]
    );

    foundBranch = branchArray.find(
      (obj) => obj[branchIdProperty] === matching[matchingBranchIdProperty]
    );

    foundSalesman =
      salesmanIdProperty &&
      salesmanArray &&
      salesmanArray.find(
        (obj) =>
          obj[salesmanIdProperty] === matching[matchingSalesmanIdProperty]
      );

    return {
      ...matching,
      __ops: matching.__ops || foundOps,
      __accounting: matching.__accounting || foundAccounting,
      __branch: matching.__branch || foundBranch,
      __salesman: matching.__salesman || foundSalesman,
    };
  };

  const getCurrencyOptions = (currSymbol) => {
    const currencySymbol = currSymbol.toUpperCase();
    const options = filteredArrays.accountCurrencies
      .filter((item) => item.symbol === currencySymbol)
      .map((option) => (
        <option
          key={option[accCurrIdProperty]}
          value={option[accCurrIdProperty]}
        >
          {option[accCurrDisplayProperty]}
        </option>
      ));

    return options;
  };

  const getCurrencySelects = () => {
    return activeCurrencies.map((currency, index) => (
      <td key={currency.libraCurrency.code || index}>
        <select
          onChange={handleAccCurrChange}
          value={newEntry.selectedAccCurr.acc_num}
          // disabled={disabled}
        >
          <option value="">Select an option</option>
          {getCurrencyOptions(currency.libraCurrency.symbol)}
        </select>
        {editRowId && newEntry.selectedAccCurr && (
          <span
            onClick={() => handleRemoveCurrency(currency)}
            style={{ cursor: "pointer", marginLeft: "5px", color: "red" }}
          >
            x
          </span>
        )}
      </td>
    ));
  };

  const getCurrencyHeaders = () => {
    return activeCurrencies.map((currency) => (
      <th key={currency.libraCurrency.code}>
        {currency.libraCurrency.symbol} Accounts
      </th>
    ));
  };

  const getCurrencyColumns = (obj) => {
    const currencyColumns = Array(activeCurrencies.length).fill("-");
      obj.accountCurrencies.forEach((accCurr) => {
        const columnIndex = activeCurrencies.findIndex(
          (currency) => +currency.libraCurrency.code === +accCurr.currency
        );

        if (columnIndex !== -1) {
          currencyColumns[columnIndex] = accCurr.acc_Num;
        }
      });
    
    // Return the currency columns as table cells
    return currencyColumns.map((accNum, index) => (
      <td key={index}>{accNum}</td>
    ));
  };

  // remove f1,f2. etc, set states and declarations of arrays inside axios call
  const refreshMatching = () => {
    f1 = opsArray;
    f2 = accountingArray;
    f3 = branchArray;
    f4 = salesmanArray;
    accCurrencies = accCurrArray;
    setMatches(transformData(existingMatches || []));

    setFilteredArrays({
      ops: f1,
      accounting: f2,
      branch: f3,
      salesman: f4,
      accountCurrencies: accCurrencies,
    });
  };

  // const getOptionLabel = (option) => option[opsDisplayProperty];
  // const getOptionValue = (option) => option[opsIdProperty];
  // const getOptionLabel2 = (option) => option[accountingDisplayProperty];
  // const getOptionValue2 = (option) => option[accountingIdProperty];
  // Generic function to get label and value for any select
  const getOptionLabel = (option, displayProperty) => option[displayProperty];
  const getOptionValue = (option, idProperty) => option[idProperty];

  const getOpsOptionLabel = (option) =>
    getOptionLabel(option, opsDisplayProperty);
  const getOpsOptionValue = (option) => getOptionValue(option, opsIdProperty);

  const getAccountingOptionLabel = (option) =>
    getOptionLabel(option, accountingDisplayProperty);
  const getAccountingOptionValue = (option) =>
    getOptionValue(option, accountingIdProperty);

  const handleOpsSelectChange = (event) => {
    if (event) {
      console.log("event in handleOpsSelectChange", event);
      const selectedId = event.id;
      setDisabled(false);
      setDisableSave(false);
      let found =
        selectedId &&
        opsArray.find((item) => `${item[opsIdProperty]}` == selectedId);
      if (found) {
        newEntry.selectedOps = selectedId;
      } else {
        newEntry.selectedOps = undefined;
      }
      let foundInMatches =
        selectedId &&
        matches.find((obj) => obj[matchingOpsIdProperty] === selectedId);
      if (foundInMatches && foundInMatches.auxiliaryId != null) {
        setDisabledMain(true);
        newEntry.selectedAccounting = foundInMatches.auxiliaryId;
        newEntry.selectedSalesman = foundInMatches.salesmanId;
      } else {
        setDisabledMain(false);
      }
      setNewEntry({
        ...newEntry,
      });
    }
  };

  const handleAccountingSelectChange = (event) => {
    // const selectedId = event.target.value;
    if (event) {
      const selectedId = event.pid;
      let found = accountingArray.find(
        (item) => `${item[accountingIdProperty]}` == selectedId
      );
      if (found) {
        newEntry.selectedAccounting = selectedId;
      } else {
        newEntry.selectedAccounting = undefined;
      }
    }
    setNewEntry({
      ...newEntry,
    });
  };

  const handleBranchSelectChange = (event) => {
    const selectedId = +event.target.value;
    let found = branchArray.find(
      (item) => item[branchIdProperty] === selectedId
    );
    if (found) {
      setNewEntry({ ...newEntry, selectedBranch: selectedId });
    } else {
      setNewEntry({ ...newEntry, selectedBranch: undefined });
    }
  };

  const handleSalesmanSelectChange = (event) => {
    const selectedId = +event.target.value;
    let found = salesmanArray.find(
      (item) => item[salesmanIdProperty] === selectedId
    );
    if (found) {
      setNewEntry({ ...newEntry, selectedSalesman: selectedId });
    } else {
      setNewEntry({ ...newEntry, selectedSalesman: undefined });
    }
  };

  const handleAccCurrChange = (event) => {
    const selectedId = +event.target.value;
    const found = accCurrArray.find(
      (item) => item[accCurrIdProperty] === selectedId
    );
    if (found) {
      setNewEntry((prevEntry) => {
        const existingEntryIndex = prevEntry.selectedAccCurr.findIndex(
          (entry) => entry.currency === found.currency
        );

        let updatedAccCurr;
        if (existingEntryIndex > -1) {
          // Update existing entry
          updatedAccCurr = [...prevEntry.selectedAccCurr];
          updatedAccCurr[existingEntryIndex] = {
            currency: found.currency,
            acc_num: found.acc_num,
          };
        } else {
          // Add new entry
          updatedAccCurr = [
            ...prevEntry.selectedAccCurr,
            { currency: found.currency, acc_num: found.acc_num },
          ];
        }

        return { ...prevEntry, selectedAccCurr: updatedAccCurr };
      });
    } else {
      setNewEntry((prevEntry) => ({
        ...prevEntry,
        selectedAccCurr: prevEntry.selectedAccCurr.filter(
          (entry) => entry.currency !== found.currency
        ),
      }));
    }
  };

  // nullifies the account currencies deleted by the user from matches
  const handleRemoveCurrency = (currencyCode) => {
    console.log(currencyCode);
    let updatedMatches = matches.map((match) => {
      return {
        ...match,
        accountCurrencies: match.accountCurrencies.map((acc) =>
          acc.currency === currencyCode.code ? { ...acc, acc_Num: null } : acc
        ),
      };
    });
    setMatches(updatedMatches);
    setNewEntry((prevEntry) => ({
      ...prevEntry,
      selectedAccCurr: prevEntry.selectedAccCurr.map((acc) =>
        acc.currency === currencyCode.code ? { ...acc, acc_Num: null } : acc
      ),
    }));
  };

  const handleEdit = (matching) => {
    console.log("matching in edit", matching);

    setEditRowId(
      `${matching[matchingOpsIdProperty]}-${matching[matchingBranchIdProperty]}-${matching[matchingLibraIdProperty]}`
    );

    // setDisabled(true);
    // setDisabledMain(true);
    setOldBranchId(matching[matchingBranchIdProperty]);

    newEntry.selectedOps = matching[matchingOpsIdProperty];
    newEntry.selectedAccounting = matching[matchingLibraIdProperty];
    newEntry.selectedBranch = matching[matchingBranchIdProperty];
    newEntry.selectedSalesman = matching[matchingSalesmanIdProperty];
    newEntry.selectedAccCurr = matching.accountCurrencies || [];
    setNewEntry({
      ...newEntry,
    });
  };

  const handleSaveClick = () => {
    const MatchingItem = {
      [matchingOpsIdProperty]: newEntry.selectedOps,
      [matchingLibraIdProperty]: newEntry.selectedAccounting,
      [matchingSalesmanIdProperty]: newEntry.selectedSalesman || null,
      [matchingBranchIdProperty]: newEntry.selectedBranch || 1,
      [matchingAccCurrCode]: newEntry.selectedAccCurr,
    };
    setEditRowId(null);
    handleSave(MatchingItem).then((newMatch) => {
      if (newMatch) {
        // Update matches state with newMatch
        setMatches((prevMatches) => {
          const updatedMatches = prevMatches.map((match) => {
            if (
              defaultMapper != IASLiveMapper &&
              match[matchingOpsIdProperty] ===
                newMatch[matchingOpsIdProperty] &&
              match[matchingBranchIdProperty] ===
                newMatch[matchingBranchIdProperty] &&
              match[matchingLibraIdProperty] ===
                newMatch[matchingLibraIdProperty]
            ) {
              // Update the existing match with new data
              return getDisplay(newMatch);
            }
            return match;
          });

          // Add new match if it doesn't exist in the current matches
          if (
            !updatedMatches.some(
              (match) =>
                match[matchingOpsIdProperty] ===
                  newMatch[matchingOpsIdProperty] &&
                match[matchingBranchIdProperty] ===
                  newMatch[matchingBranchIdProperty] &&
                match[matchingLibraIdProperty] ===
                  newMatch[matchingLibraIdProperty]
            )
          ) {
            updatedMatches.push(getDisplay(newMatch));
          }
          return updatedMatches;
        });

        // Reset the form
        setNewEntry({
          selectedOps: "",
          selectedAccounting: "",
          selectedBranch: "",
          selectedSalesman: "",
          selectedAccCurr: [],
        });
      }
    });
  };

  function handleDeleteClick(matching) {
    handleDelete(matching);
  }

  function transformData(data) {
    const rows = [];
    data.forEach((entry) => {
        entry.branches.forEach((branch) => {
          rows.push(
            getDisplay({
              [matchingOpsIdProperty]: entry.opsId,
              [matchingLibraIdProperty]: entry.auxiliaryId,
              [matchingSalesmanIdProperty]: entry.salesmanId,
              [matchingBranchIdProperty]: branch.branchId,
              accountCurrencies: branch.accountCurrencies,
            })
          );
        });
      
    });
    return rows;
  }

  useEffect(() => {
    refreshMatching();
  }, [opsArray, accountingArray, branchArray, salesmanArray]);

  useEffect(() => {}, [matches, newEntry]);

  return (
    <Fragment>
      <Table col-4 hover bordered="false" responsive order mt-4>
        <thead>
          <tr>
            <th>{columnTitle}</th>
            <th>Auxiliary</th>
            {defaultMapper != IASLiveMapper && <th>Branch</th>}
            {defaultMapper != IASLiveMapper && salesmanArray && (
              <th>Salesman</th>
            )}
            {getCurrencyHeaders()}
            <td></td>
          </tr>
        </thead>
        <tbody>
          {matches && matches.length > 0 ? (
            matches.map((matching) => {
              const rowKey = `${matching[matchingOpsIdProperty]}-${matching[matchingBranchIdProperty]}-${matching[matchingLibraIdProperty]}`;
              const isEditing = editRowId === rowKey;
              const foundOpsName = matching.__ops;
              const foundAccountingName = matching.__accounting;
              const foundBranchName = matching.__branch;
              const foundSalesman = matching.__salesman;
              const currencyColumns = getCurrencyColumns(matching);

              return (
                <tr key={rowKey}>
                  <td>
                    {foundOpsName ? foundOpsName[opsDisplayProperty] : "N/A"}
                  </td>
                  <td>
                    {isEditing ? (
                      <select
                        name="selectedAccounting"
                        value={newEntry.selectedAccounting}
                        onChange={handleAccountingSelectChange}
                      >
                        <option value="">Select an option</option>
                        {filteredArrays.accounting.map((option) => (
                          <option
                            key={option[accountingIdProperty]}
                            value={option[accountingIdProperty]}
                          >
                            {option[accountingDisplayProperty]}
                          </option>
                        ))}
                      </select>
                    ) : foundAccountingName ? (
                      foundAccountingName[accountingDisplayProperty]
                    ) : (
                      "N/A"
                    )}
                  </td>
                  {defaultMapper != IASLiveMapper && (
                    <td>
                      {isEditing ? (
                        <select
                          name="selectedBranch"
                          value={newEntry.selectedBranch}
                          onChange={handleBranchSelectChange}
                          // disabled={disabled}
                        >
                          <option value="">Select an option</option>
                          {filteredArrays.branch.map((option) => (
                            <option
                              key={option[branchIdProperty]}
                              value={option[branchIdProperty]}
                            >
                              {option[branchDisplayProperty]}
                            </option>
                          ))}
                        </select>
                      ) : foundBranchName ? (
                        foundBranchName[branchDisplayProperty]
                      ) : (
                        "N/A"
                      )}
                    </td>
                  )}
                  {defaultMapper != IASLiveMapper && salesmanArray && (
                    <td>
                      {isEditing ? (
                        <select
                          name="selectedSalesman"
                          value={newEntry.selectedSalesman}
                          onChange={handleSalesmanSelectChange}
                          disabled={disabledMain}
                        >
                          <option value="">Select an option</option>
                          {filteredArrays.salesman.map((option) => (
                            <option
                              key={option[salesmanIdProperty]}
                              value={option[salesmanIdProperty]}
                            >
                              {option[salesmanDisplayProperty]}
                            </option>
                          ))}
                        </select>
                      ) : foundSalesman ? (
                        foundSalesman[salesmanDisplayProperty]
                      ) : (
                        "N/A"
                      )}
                    </td>
                  )}
                  {isEditing ? getCurrencySelects() : currencyColumns}

                  <td className={classes.actionBtn}>
                    <Button
                      variant="outline-danger"
                      onClick={() => handleDeleteClick(matching)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="8">No matches found</td>
            </tr>
          )}
          <tr>
            <td>
              <div>
                <Select
                  menuPlacement="top"
                  options={filteredArrays.ops}
                  getOptionLabel={(option) => getOpsOptionLabel(option)}
                  getOptionValue={(option) => getOpsOptionValue(option)}
                  // value={newEntry.selectedOps}
                  onChange={handleOpsSelectChange}
                  isClearable={true}
                  isSearchable={true}
                  placeholder="Select an option"
                />
              </div>
            </td>
            <td>
              <div>
                <Select
                  menuPlacement="top"
                  options={filteredArrays.accounting}
                  getOptionLabel={(option) => getAccountingOptionLabel(option)}
                  getOptionValue={(option) => getAccountingOptionValue(option)}
                  // value={newEntry.selectedOps}
                  onChange={handleAccountingSelectChange}
                  isClearable={true}
                  isSearchable={true}
                  placeholder="Select an option"
                />
              </div>
            </td>
            {defaultMapper != IASLiveMapper && (
              <td>
                <div>
                  {filteredArrays.branch && filteredArrays.branch.length > 0 ? (
                    <select
                      name="selectedBranch"
                      value={newEntry.selectedBranch}
                      onChange={handleBranchSelectChange}
                      // disabled={disabled}
                    >
                      <option value="">Select an option</option>
                      {filteredArrays.branch.map((option) => (
                        <option
                          key={option[branchIdProperty]}
                          value={option[branchIdProperty]}
                        >
                          {option[branchDisplayProperty]}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <p>No Branch Data</p>
                  )}
                </div>
              </td>
            )}
            {defaultMapper != IASLiveMapper && salesmanArray && (
              <td>
                <div>
                  {filteredArrays.salesman &&
                  filteredArrays.salesman.length > 0 ? (
                    <select
                      name="selectedSalesman"
                      value={newEntry.selectedSalesman}
                      onChange={handleSalesmanSelectChange}
                      disabled={disabledMain}
                    >
                      <option value="">Select an option</option>
                      {filteredArrays.salesman.map((option) => (
                        <option
                          key={option[salesmanIdProperty]}
                          value={option[salesmanIdProperty]}
                        >
                          {option[salesmanDisplayProperty]}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <p>No Salesman Data</p>
                  )}
                </div>
              </td>
            )}
            {getCurrencySelects()}
            <td></td>
          </tr>
        </tbody>
      </Table>

      <Link to="/">
        <Button variant="outline-danger">Main Menu</Button>
      </Link>
      <Button
        variant="outline-success"
        onClick={handleSaveClick}
        disabled={disableSave}
      >
        Save
      </Button>
    </Fragment>
  );
}
